module.exports = __webpack_public_path__ + "static/media/icon-admin-review.1b67d7a8.svg";